import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  notification,
  Select,
} from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { GET, POST } from "../../../utils/apiRequest";
import { API } from "../../../config/Api";
import Loading from "../../../components/loading";
import SettleDataTable from "./dataTable";
import NoData from "../../components/noData";
import { Col, Row } from "react-bootstrap";
import { ExportToExcel } from "../../../utils/exportToExcel";
import { SiMicrosoftexcel } from "react-icons/si";
import moment from "moment";
import { IoReload } from "react-icons/io5";

// Define TypeScript interfaces
interface Package {
  id: number;
  name: string;
  cardNo?: string;
}

interface ReportData {
  totalAmount: number;
  totalTickets: number;
}

interface Summary {
  totalAmount: number;
  totalTickets: number;
}

const SettleReport = (props: any) => {
  const [form] = useForm();
  const { Option } = Select;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [take, setTake] = useState<number>(10);
  const [meta, setMeta] = useState<any>({});

  const [sdate, setSdate] = useState<string>(
    dayjs(new Date()).subtract(10, "day").format("YYYY-MM-DD")
  );
  const [ldate, setLdate] = useState<string>(
    dayjs(new Date()).format("YYYY-MM-DD")
  );
  const dateFormat = "YYYY/MM/DD";
  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );

  const [packageData, setPackageData] = useState<ReportData[]>([]);
  const [startDate, setStartDate] = useState<Date>(firstDayOfMonth);
  const [endDate, setEndDate] = useState<Date>(lastDayOfMonth);
  const [isLoading2, setIsLoading2] = useState<boolean>(false);
  const [references, setRefs] = useState<Package[]>([]);
  const [selectedRef, setSelectedRef] = useState<Package | null>(null);
  const [summary, setSummary] = useState<Summary>({
    totalAmount: 0,
    totalTickets: 0,
  });

  // Fetch packages and initial report
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await Promise.all([fetchReferences()]);
      } catch (error) {
        console.error("Error fetching initial data:", error);
        notification.error({
          message: "Error fetching initial data",
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  // Fetch available packages
  const fetchReferences = async () => {
    try {
      const response: any = await POST(API.CARDS_LIST, {
        status: false,
        page: 1,
        take: 2000,
      });
      console.log("response -->", response);
      if (response?.status) {
        setRefs(response.data);
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
      notification.error({
        message: "Error fetching packages",
      });
    }
  };

  const getReport = async (page: number = 1, take: number = 10) => {
    try {
      setIsLoading2(true);
      const api = API.SETTLE_REPORT;
      const formData = form.getFieldsValue();

      const start = formData.date
        ? moment(formData.date[0].$d).startOf("month")
        : moment().startOf("month");
      const end = formData.date
        ? moment(formData.date[1].$d).endOf("month")
        : moment().endOf("month");

      setStartDate(start.toDate());
      setEndDate(end.toDate());

      const obj = {
        cardNo: Number(formData.cardNo),
        startDate: start.format("YYYY-MM-DD"),
        endDate: end.format("YYYY-MM-DD"),
        page,
        take,
      };
      const report: any = await POST(api, obj);
      console.log("report -->", report);
      if (report?.status) {
        calculateTotal(report.data);
        setPackageData(report.data);
      } else {
        setPackageData([]);
        notification.error({
          message: "Data not available",
        });
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      notification.error({
        message: "Error fetching report",
      });
    } finally {
      setIsLoading2(false);
    }
  };

  const calculateTotal = (data: ReportData[]) => {
    const totals = data.reduce(
      (acc: Summary, val: ReportData) => {
        acc.totalAmount += Number(val.totalAmount) || 0;
        acc.totalTickets += Number(val.totalTickets) || 0;
        return acc;
      },
      { totalAmount: 0, totalTickets: 0 }
    );
    setSummary(totals);
  };

  return (
    <div className="screenBox">
      <Card
        title={<div className="title1">Select Referenced Card</div>}
        extra={
          <div className="PageHeaderBox">
            <Button className="refreshBtn" onClick={() => getReport()}>
              <IoReload color="#000" size={15} />
            </Button>
          </div>
        }
      >
        <div className="">
          <br />
          <Form form={form} onFinish={() => getReport()}>
            <Row>
              <Col md="4">
                <Form.Item
                  name={"cardNo"}
                  rules={[
                    {
                      required: true,
                      message: "Select a card",
                    },
                  ]}
                >
                  <Select
                    size="large"
                    style={{ width: "100%" }}
                    allowClear
                    showSearch={true}
                    placeholder={"Select Package"}
                    onChange={(value: number, option: any) =>
                      setSelectedRef(option)
                    }
                    defaultValue={undefined}
                    loading={isLoading}
                  >
                    {references?.map((option: Package, idx: number) => (
                      <Option key={idx} value={option.cardNo}>
                        {option.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col md="3">
                <Form.Item name={"date"}>
                  <DatePicker.RangePicker
                    size="large"
                    picker="month"
                    style={{ width: "100%" }}
                    onChange={(_, val: string[]) => {
                      setSdate(val[0]);
                      setLdate(val[1]);
                    }}
                    defaultValue={[dayjs(startDate), dayjs(endDate)]}
                    // format={dateFormat}
                  />
                </Form.Item>
              </Col>

              <Col md="1"></Col>

              <Col md="2">
                <Button
                  onClick={() =>
                    ExportToExcel(
                      references,
                      `${selectedRef?.cardNo || "report"}`
                    )
                  }
                  size="large"
                  style={{ width: "100%" }}
                  disabled={!references.length}
                >
                  <SiMicrosoftexcel color="#08493e" size={20} /> Export
                </Button>
              </Col>

              <Col md="2">
                <Button
                  loading={isLoading2}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Get Report
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
        <br />

        {isLoading ? (
          <Loading />
        ) : references?.length ? (
          <>
            <hr />
            <br />
            <SettleDataTable
              activity={selectedRef}
              summary={summary}
              data={references}
              loading={isLoading2}
            />
          </>
        ) : (
          <NoData />
        )}
      </Card>
    </div>
  );
};

export default SettleReport;

// import {
//   Button,
//   Card,
//   DatePicker,
//   Form,
//   Input,
//   notification,
//   Select,
// } from "antd";
// import { useForm } from "antd/es/form/Form";
// import dayjs from "dayjs";
// import { useEffect, useState } from "react";
// import { CiSearch } from "react-icons/ci";
// import { GET, POST } from "../../../utils/apiRequest";
// import { API } from "../../../config/Api";
// import Loading from "../../../components/loading";
// import SettleDataTable from "./dataTable";
// import NoData from "../../components/noData";
// import { Col, Row } from "react-bootstrap";
// import { ExportToExcel } from "../../../utils/exportToExcel";
// import { SiMicrosoftexcel } from "react-icons/si";
// import moment from "moment";
// import { IoReload } from "react-icons/io5";

// const SettleReport = (props: any) => {
//   const [form] = useForm();
//   const { Option } = Select;
//   const [isLoading, setIsLoading] = useState(true);
//   const [page, setPage] = useState(1);
//   const [take, setTake] = useState(10);
//   const [meta, setMeta] = useState<any>({});

//   const [sdate, setSdate] = useState<any>(
//     dayjs(new Date()).subtract(10, "day").format("YYYY-MM-DD")
//   );
//   const [ldate, setLdate] = useState<any>(
//     dayjs(new Date()).format("YYYY-MM-DD")
//   );
//   const dateFormat = "YYYY/MM/DD";
//   const currentDate = new Date();
//   const firstDayOfMonth = new Date(
//     currentDate.getFullYear(),
//     currentDate.getMonth(),
//     1
//   );
//   const lastDayOfMonth = new Date(
//     currentDate.getFullYear(),
//     currentDate.getMonth() + 1,
//     0
//   );

//   const [packageData, setPackageData] = useState([]);
//   const [startDate, setStartDate] = useState(firstDayOfMonth) as any;
//   const [endDate, setEndDate] = useState(lastDayOfMonth) as any;
//   const [isLoading2, setIsLoading2] = useState(false);
//   const [packages, setPackages] = useState([]);
//   const [selectedRef, setSelectedRef] = useState<any>({});
//   const [summary, setSummary] = useState<any>({});

//   useEffect(() => {
//     getReport(page, take);
//   }, []);

//   const getReport = async (page: any = 1, take: any = 10) => {
//     try {
//       setIsLoading2(true);
//       let api = API.SETTLE_REPORT;
//       const formData = form.getFieldsValue();
//       const start = formData.date
//         ? moment(formData.date[0].$d).startOf("month")
//         : moment().startOf("month");
//       const end = formData.date
//         ? moment(formData.date[1].$d).endOf("month")
//         : moment().endOf("month");
//       setStartDate(start);
//       setEndDate(end);
//       const obj = {
//         package: Number(formData.package),
//         startDate: start,
//         endDate: end,
//         page,
//         take,
//       };
//       const report: any = await POST(api, obj);
//       console.log("report -->", report);
//       if (report?.status) {
//         calculateTotal(report?.data);
//         setPackageData(report?.data);
//         setIsLoading2(false);
//       } else {
//         setIsLoading2(false);
//         setPackageData([]);
//         notification.error({
//           message: "Data not available",
//         });
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const calculateTotal = (data: any[]) => {
//     const totals = data?.reduce(
//       (acc: any, val: any) => {
//         acc.totalAmount += Number(val.totalAmount);
//         acc.totalTickets += Number(val.totalTickets);
//         return acc;
//       },
//       { totalAmount: 0, totalTickets: 0 }
//     );
//     setSummary(totals);
//   };

//   return (
//     <div className="screenBox">
//       <Card
//         title={<div className="title1">Select Referenced Card</div>}
//         extra={
//           <div className="PageHeaderBox">
//             <Button className="refreshBtn" onClick={() => getReport()}>
//               <IoReload color="#000" size={15} />
//             </Button>
//           </div>
//         }
//       >
//         <div className="">
//           <br />
//           <Form form={form} onFinish={() => getReport()}>
//             <Row>
//               <Col md="4">
//                 <Form.Item
//                   name={"package"}
//                   noStyle
//                   rules={[
//                     {
//                       required: true,
//                       message: "Select a staff",
//                     },
//                   ]}
//                 >
//                   <Select
//                     size="large"
//                     style={{ width: "100%" }}
//                     allowClear
//                     showSearch={true}
//                     placeholder={"Select Package"}
//                     onChange={(data: any, val: any) => setSelectedRef(val)}
//                     defaultValue={"Select Package"}
//                     loading={isLoading}
//                   >
//                     {packages?.map((option: any) => (
//                       <Option key={option.id} value={option.id}>
//                         {option.name}
//                       </Option>
//                     ))}
//                   </Select>
//                 </Form.Item>
//               </Col>

//               <Col md="3">
//                 <Form.Item name={"date"} noStyle>
//                   <DatePicker.RangePicker
//                     size="large"
//                     picker="month"
//                     style={{ width: "100%" }}
//                     onChange={(_, val: any) => {}}
//                     defaultValue={[dayjs(startDate), dayjs(endDate)]}
//                   />
//                 </Form.Item>
//               </Col>

//               <Col md="1"></Col>

//               <Col md="2">
//                 <Button
//                   onClick={() =>
//                     ExportToExcel(packageData, `${selectedRef?.cardNo}`)
//                   }
//                   size="large"
//                   style={{ width: "100%" }}
//                 >
//                   <SiMicrosoftexcel color="#08493e" size={20} /> &nbsp;Export
//                 </Button>
//               </Col>

//               <Col md="2">
//                 <Button
//                   loading={isLoading2}
//                   type="primary"
//                   size="large"
//                   htmlType="submit"
//                   style={{ width: "100%" }}
//                 >
//                   Get Report
//                 </Button>
//               </Col>
//             </Row>
//           </Form>
//         </div>
//         <br />

//         {/* //PackageDataTable */}

//         {packageData?.length ? (
//           <>
//             <hr />
//             <br />
//             <SettleDataTable
//               activity={selectedRef}
//               summary={summary}
//               data={packageData}
//               loading={isLoading}
//             />
//           </>
//         ) : (
//           <NoData />
//         )}
//       </Card>
//     </div>
//   );
// };

// export default SettleReport;
